import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from "react-router-dom";
import { IconButton } from '@fluentui/react';
import { __onGoToBoardCartera } from '../../../../../../common/SystemRedirections';
import { __onGetDataGridHtmlContainer } from '../../../../../../common/CommonFuctions';
import { enum__Clients } from '../../../../../../common/Dictionaries';
import { authGetClient } from '../../../../../../actions/auth-action';

function HEADER_TOOLBAR(props) {
    const history = useHistory();
    const { t } = useTranslation();

    const { 
        inputParam_BoardStructure = null,
        inputParam_Container = null
    } = props;

    const findLastElementInFirstRow = (items) => {
        let lastElement = null;
        let maxRightPosition = -1;
      
        items.forEach(item => {
          if (item.y === 0) { // Es parte de la primera fila
            const rightPosition = item.x + item.w;
            if (rightPosition > maxRightPosition) {
              maxRightPosition = rightPosition;
              lastElement = item;
            }
          }
        });
      
        return lastElement;
    }

    const getHtmlContainer = (item) => {
      const html = __onGetDataGridHtmlContainer(item);

      return html.lg ? html.lg : html;
    }

    const lastFirstRowContainerInternalId = inputParam_BoardStructure ?
        (
          findLastElementInFirstRow(inputParam_BoardStructure.length !== undefined && inputParam_BoardStructure.length > 0 ?
            inputParam_BoardStructure[0].l_structure[0].l_container.map(x => getHtmlContainer(x)) :
            inputParam_BoardStructure.l_structure[0].l_container.map(x => getHtmlContainer(x))).i
        ) : null;
    
    const currentContainerIntenalId = inputParam_Container ? __onGetDataGridHtmlContainer(inputParam_Container).i : null
    const isCurrentContainerLastOfFirstRow = inputParam_BoardStructure && inputParam_Container ? (lastFirstRowContainerInternalId === currentContainerIntenalId) : null;

    return (<div className='toolbar d-flex my-auto' id={"filter-board-field-callout-button"}>
                {
                    isCurrentContainerLastOfFirstRow &&
                    <IconButton title={t('data-lang-pagename-boardcarteras')} onClick={() => __onGoToBoardCartera(history)} iconProps={{iconName: "FabricReportLibrary"}} styles={{ icon: { fontSize: 20 } }} />
                }
            </div>);
}

HEADER_TOOLBAR.propTypes = {

};

export default HEADER_TOOLBAR;






